var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFaq = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 16 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "faq_svg__a",
  d: "M8.333 5.333a.667.667 0 1 1 1.334 0 .667.667 0 0 1-1.334 0M3.667 6a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333m2-.667a.667.667 0 1 1 1.333 0 .667.667 0 0 1-1.333 0m9 6A.667.667 0 0 1 14 12a.67.67 0 0 0-.533.267L12 14.222l-1.467-1.955A.67.67 0 0 0 10 12H5.333l1-1.333h4.334c1.102 0 2-.897 2-2V4H14c.368 0 .667.299.667.667zM2.533 9.6A.67.67 0 0 0 2 9.333a.667.667 0 0 1-.667-.666V2c0-.368.3-.667.667-.667h8.667c.367 0 .666.3.666.667v6.667a.667.667 0 0 1-.666.666H6a.67.67 0 0 0-.533.267L4 11.555zM14 2.667h-1.333V2c0-1.103-.898-2-2-2H2C.897 0 0 .897 0 2v6.667c0 .98.71 1.799 1.643 1.968l1.824 2.432a.663.663 0 0 0 1.002.068 2 2 0 0 0 .864.198h4.334l1.8 2.4a.667.667 0 0 0 1.066 0l1.824-2.432A2 2 0 0 0 16 11.333V4.667c0-1.103-.897-2-2-2"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "faq_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#faq_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#faq_svg__a",
  fill: "#DF0000"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#CDCACA",
  mask: "url(#faq_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
})))));
export default SvgFaq;